module.exports = __webpack_public_path__ + "food-48.02346c372953b01c47ef.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/food/webfont/food-48.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/food/webfont/food-48.woff
// module chunks = styles